import pagination from '@/helpers/pagination';

const {
    actions: baseActions,
    types,
    reducer,
} = pagination('requestList');

const actions = {
    requestFetchRequestList: baseActions.request,
    fetchRequestListSucceeded: baseActions.succeeded,
    fetchRequestListFailed: baseActions.failed,
};

export { types, actions };

export default reducer;
